import React from 'react';
import './footer.css';

interface StaticFooterProps {
  className?: string;
}

const StaticFooter: React.FC<StaticFooterProps> = ({ className }) => {
  return (
    <footer className={`footer ${className || ''}`} data-testid='footer'>
      <div className='container'>
        <div className='row'>
          <div className='left-column'>
            <ul>
              <li>
                <a
                  href='https://www.ald-online.de/pages/datenschutz'
                  target='_blank'
                  rel='noreferrer'
                >
                  Datenschutzhinweise Website
                </a>
              </li>
              <li>
                <a
                  href='https://cdn.ald-online.de/cms/assets/ALD_Datenschutzhinweise_Kunden_ALD_Online_DMC_4c6d6ea5d9.pdf'
                  target='_blank'
                  rel='noreferrer'
                >
                  Datenschutzhinweise für Kunden
                </a>
              </li>
              <li>
                <a className='privacy-settings' href='#/'>
                  Privatsphäre-Einstellungen
                </a>
              </li>
              <li>
                <a
                  className='impressum-link'
                  href='https://www.ald-online.de/pages/impressum'
                  target='_blank'
                  rel='noreferrer'
                >
                  Impressum
                </a>
              </li>
              <li>
                <a
                  id='agb-link'
                  href='https://cdn.ald-online.de/cms/assets/ALD_AGB_Gewerblich_Online_B2_B_ALD_Online_a01f8a9d02.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Allgemeine Geschäftsbedingungen (AGB)
                </a>
              </li>
              <li>
                <a
                  href='https://report.whistleb.com/de/AyvensDE'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Whistleblowing
                </a>
              </li>
              <li>
                <a
                  href='https://mobility.ayvens.de/pages/Verhaltenskodex'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Verhaltenskodex
                </a>
              </li>
              <li>
                <a
                  href='https://www.societegenerale.com/en'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Société Générale
                </a>
              </li>
            </ul>
          </div>
          <div className='right-column'>
            <ul>
              <li>Geschäftszeiten:</li>
              <li>Mo-Do: 08:00 - 18:00, Fr: 8:00 - 16:00</li>
              <li>
                Tel: <a href='tel:+4940471041850'>+49 40 47104-1850</a>
              </li>
              <li id='email-display'>marketplace@aldautomotive.com</li>
              <li>
                <a href='mailto:ald.flex@aldautomotive.com'>
                  ald.flex@aldautomotive.com
                </a>
              </li>

              <li>
                <a
                  href='https://www.ayvens.de'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  www.ayvens.de
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='full-width-column'>
          ALD AutoLeasing D GmbH, Nedderfeld 95, 22529 Hamburg, Postfach 570328,
          22772 Hamburg, Verwaltungsratsvorsitzender: Berno Kleinherenbrink,
          Geschäftsführer: Martin Kössler, Dr. Stefan Koch, Amtsgericht Hamburg,
          HRB 30468, Ust-ID: DE 118528033, Gläubiger-ID: DE38ZZZ00000503782
        </div>
      </div>
    </footer>
  );
};

export default StaticFooter;
